// Iconos del menú.
//
// Dibujados a mano y en línea a propósito: la CSP no permite imágenes ni
// scripts externos (`img-src 'self' data:`), así que una librería de iconos por
// CDN está descartada, y traerse un paquete entero para quince trazos añade
// peso a la descarga de cada persona que abre el portal.
//
// Todos comparten rejilla de 24, trazo de 1.5 y extremos redondeados, que es
// lo que hace que un conjunto dibujado a mano no parezca dibujado a mano.

export type NombreIcono =
  | "tablero"
  | "en-curso"
  | "llamadas"
  | "apps"
  | "numeros"
  | "callerid"
  | "playground"
  | "webhooks"
  | "saldo"
  | "consumo"
  | "limites"
  | "llaves"
  | "usuarios"
  | "seguridad"
  | "tarifas"
  | "cuentas"
  | "troncales"
  | "nodos"
  // Los de las tablas. Van en el mismo catálogo y no en el componente de
  // tabla: un segundo juego de iconos acaba con dos estilos de trazo en la
  // misma pantalla.
  | "orden"
  | "orden-asc"
  | "orden-desc"
  | "menu"
  | "buscar"
  | "filtro"
  | "columnas"
  | "check";

const TRAZOS: Record<NombreIcono, string> = {
  tablero: "M4 13h6V4H4v9Zm0 7h6v-5H4v5Zm10 0h6v-9h-6v9Zm0-16v5h6V4h-6Z",
  // Una línea de actividad, no un teléfono: «En curso» no es otra lista de
  // llamadas, es lo que está pasando ahora.
  "en-curso": "M3 12h4l2.5-6 4 12 2.5-6h5",
  llamadas:
    "M5 4h3l1.5 4-2 1.5a12 12 0 0 0 5 5L14 12l4 1.5V17a2 2 0 0 1-2.2 2A15.5 15.5 0 0 1 3 6.2 2 2 0 0 1 5 4Z",
  apps: "M4 6h16M4 12h10M4 18h7M18 15v6M15 18h6",
  numeros: "M9 4v16M15 4v16M4 9h16M4 15h16",
  callerid: "M12 3l8 4v5c0 4.5-3.2 7.9-8 9-4.8-1.1-8-4.5-8-9V7l8-4Zm-3 9 2 2 4-4",
  playground: "M5 5h14v10H5zM9 19h6M12 15v4M9 8l3 2-3 2",
  webhooks: "M9 7a3 3 0 1 1 4.5 2.6L16 14M7 11l-2.5 4.3A3 3 0 1 0 9 18h8",
  saldo: "M3 8h18v10H3zM3 8l3-4h12l3 4M8 13h4",
  consumo: "M4 19V9M9 19V5M14 19v-7M19 19v-4",
  limites: "M12 3v18M3 12h18M7 7l10 10M17 7 7 17",
  llaves: "M14 7a4 4 0 1 1-3.5 5.9L4 19.5V21h3v-2h2v-2h2l1.5-1.5",
  usuarios:
    "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-6 9a6 6 0 0 1 12 0M16 11a3 3 0 1 0 0-6M17 20h4a5 5 0 0 0-3-4.6",
  seguridad: "M12 3l8 4v5c0 4.5-3.2 7.9-8 9-4.8-1.1-8-4.5-8-9V7l8-4ZM12 11v4M12 8.5v.5",
  tarifas: "M4 7h16M4 12h10M4 17h7M17 13l3 3-3 3M20 16h-6",
  cuentas: "M4 20V9l8-5 8 5v11M9 20v-6h6v6M4 20h16",
  troncales: "M4 8h4v8H4zM16 8h4v8h-4zM8 12h8M10 10l-2 2 2 2M14 10l2 2-2 2",
  nodos: "M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM5 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm14 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM12 7v4M12 11 6 16M12 11l6 5",
  // Dos flechas opuestas: «esta columna se puede ordenar, y ahora mismo no lo
  // está». Las de una sola punta dicen el orden actual.
  orden: "M8 9l4-4 4 4M8 15l4 4 4-4",
  "orden-asc": "M12 19V5M6 11l6-6 6 6",
  "orden-desc": "M12 5v14M6 13l6 6 6-6",
  menu: "M12 6h.01M12 12h.01M12 18h.01",
  buscar: "M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14ZM20 20l-4-4",
  filtro: "M4 6h16l-6 7v5l-4 2v-7L4 6Z",
  columnas: "M4 5h16v14H4zM10 5v14M16 5v14",
  check: "M5 12l4 4 10-10",
};

export function Icono({ nombre, className = "" }: { nombre: NombreIcono; className?: string }) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d={TRAZOS[nombre]} />
    </svg>
  );
}
